// eslint-disable-next-line no-shadow
export enum HubriseAccessLevel {
    ACCOUNT = 'account',
    LOCATION = 'location',
    PROFILE = 'profile'
}
